import { TextField, TextInput } from "react-admin";

import { Action, DataKind, Region, Resource } from "../../types";
import { routes } from "../../utils/Routes";
import {
  ActionMenu,
  CustomDateTimeField,
  CustomList,
  CustomMenuItem,
  CustomReferenceField,
} from "../custom";

// Custom Actions

function AuditLogsConfigVariables(props: { region: Region }) {
  return (
    // We use the following directive to suppress the type errors arising from
    // usage of the `component` and `href` props. Despite the type errors, the
    // component works as expected with the props.
    <CustomMenuItem
      // @ts-expect-error
      component="a"
      href={routes.computeAuditLogForConfigVariables(props.region)}
    >
      Audit Logs
    </CustomMenuItem>
  );
}

// "By default, <List> does not refresh the data as soon as the user enters
// data in the filter form. Instead, it waits for half a second of user
// inactivity (via `lodash.debounce`) before calling the dataProvider
// on filter change. This is to prevent repeated calls to the API."
//
// Source: https://marmelab.com/react-admin/List.html#debounce
const configVariableFilters = [
  <TextInput label="Name" source="name_like" alwaysOn />,
  <TextInput label="Value" source="value_like" alwaysOn />,
  <TextInput
    label="Last Editor Admin User Id"
    source="last_editor_admin_user_id_eq"
    alwaysOn
  />,
];

function ConfigVariableList(props: { region: Region }) {
  const fieldwireActions = [
    {
      checkPermissionForAction: Action.Read,
      checkPermissionForDataKind: DataKind.ConfigVariable,
      element: <AuditLogsConfigVariables region={props.region} />,
    },
  ];

  return (
    <CustomList
      checkPermissionFor={DataKind.ConfigVariable}
      displayCreate={true}
      filters={configVariableFilters}
      fieldwireActions={<ActionMenu fieldwireActions={fieldwireActions} />}
    >
      <TextField label="Id" source="id" />
      <CustomDateTimeField label="Created At" source="created_at" />
      <CustomDateTimeField label="Updated At" source="updated_at" />
      <CustomReferenceField
        label="Last Editor Admin User"
        source="last_editor_admin_user_id"
        reference={Resource.AdminUser}
      >
        <TextField source="email" />
      </CustomReferenceField>
      <TextField label="Name" source="name" />
      <TextField label="Value" source="value" />
    </CustomList>
  );
}

export default ConfigVariableList;
